"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiDialogContentTextOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            marginBottom: spacing(8),
        },
    });
};
//# sourceMappingURL=MuiDialogContentText.js.map